import React from 'react';
import { Link, graphql } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';
import { SliceZone } from '../components/SliceZone';



function CompanyPage({ data: { prismicCompanyPage }, ...restProps }) {
  const { data } = prismicCompanyPage;

  return (
    <Layout {...restProps}>
      <SEO title="Company" />
      <SliceZone allSlices={data.body} />
    </Layout>
  );
}

export default CompanyPage;

export const pageQuery = graphql`
  {
    prismicCompanyPage {
      id
      data {
        body {
          ... on PrismicCompanyPageBodySectionHeader {
            id
            slice_type
            primary {
              description {
                text
              }
              tagline {
                text
              }
              paragraph {
                text
              }
              background_color
            }
          }

          ... on PrismicCompanyPageBodyText {
            id
            slice_type
            primary {
              text {
                html
              } 
            }
          }
          ... on PrismicCompanyPageBodyImage {
            id
            slice_type
            primary {
              main_image {
                url
              }
              mobile_image {
                url
              }
            }
          }
          ... on PrismicCompanyPageBodyLogoIconSection {
            id
            slice_type
            primary {
              max_columns
            }
            items {
              icon {
                url
              }
            }
          }
          ... on PrismicCompanyPageBodyPeopleGridSection {
            id
            slice_type
            items {
              image {
                url
              }
              person_name {
                text
              }
              person_title {
                text
              }
            }
          }
          ... on PrismicCompanyPageBodyValuesGridSection {
            id
            slice_type
            primary {
              cta_description {
                text
              }
              cta_button_label {
                text
              }
            }
            items {
              name {
                text
              }
              description {
                text
              }
            }
          }
          
          ... on PrismicCompanyPageBodyArticleListSection {
            id
            slice_type
            items {
              date
              source {
                text
              }
              headline {
                text
              }
              link {
                url
              }
            }
          }
        }
      }
    }
  }
`;
